/**
 * API base URL — cloud / reverse-proxy first.
 *
 * - Production (Pages → Workers): leave VITE_API_URL unset; browser calls `/api` (Pages _redirects)
 * - Staging (Tower tunnel): leave unset; vite preview proxies `/api` → :8788
 *   and Vite/nginx proxies to the Node API on :8788.
 * - Optional override: VITE_API_URL=https://api.example.com
 */
export function apiBaseUrl(): string {
  const explicit = import.meta.env.VITE_API_URL as string | undefined;
  if (explicit?.trim()) {
    return explicit.replace(/\/$/, '');
  }
  return '/api';
}
